<!--送培第0步 报名信息-->
<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-form
          :model="formData"
          label-width="120px"
          ref="ruleForm"
          class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="场次" prop="saiqu">
              <el-input
                  type="text"
                  disabled
                  v-model="formData.saiqu_name"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单位" prop="danwei">
              <el-input
                  type="text"
                  disabled
                  v-model="formData.danwei"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系人" prop="ldname"
                          :rules="[
                { required: true, message: '联系人不能为空', trigger: 'blur' },
              ]"
            >
              <el-input
                  type="text"
                  placeholder="请输入联系人"
                  v-model="formData.ldname"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="ldnum">
              <el-input
                  type="text"
                  placeholder="请输入身份证号"
                  v-model="formData.num"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
                label="手机"
                prop="phone"
                :rules="[
                {
                  required: true,
                  validator: validator.phone,
                  message: '请输入正确的手机号',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-input
                  v-model="formData.phone"
                  placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                label="邮箱"
                prop="email"
                :rules="[
                {
                  required: true,
                  validator: validator.email,
                  message: '请输入正确的邮箱',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-input
                  v-model="formData.email"
                  placeholder="请输入邮箱"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
                label="收件地区选择"
                prop="area"
                :rules="[
                {
                  required: true,
                  message: '请选择收件地区',
                },
              ]"
            >
              <el-cascader
                  v-model="formData.area"
                  ref="areas"
                  @change="handleAreasChange"
                  :options="areaOptions"
                  :props="{ label: 'title' }"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                label="收件详细地址"
                prop="address"
            >
              <el-input
                  type="text"
                  placeholder="请输入详细地址"
                  v-model="formData.address"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">下一步
            </el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>-->
          </el-col>
        </el-row>
      </el-form>
      <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
    </div>
  </div>
</template>
<style scoped>

</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Dialog,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';
import CaipanPicker from '@/components/picker/CaipanPicker.vue';
import JiaolianPicker from '@/components/picker/JiaolianPicker.vue';
import LoginDialog from '@/components/LoginDialog.vue';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Dialog).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'SongpeiApplyFormStep1',
  components: {
    [Field.name]: Field,
    PicUploader,
    CaipanPicker,
    JiaolianPicker,
    LoginDialog
  },
  data: function () {
    return {
      validator,
      loginShow: false,
      saveLoading: false,
      saiqu_id: this.$route.query.saiqu_id,
      numTypeColumns: ['身份证', '护照'],
      showArea: false,
      areaList: {},
      areaOptions: [],
      areaValue: '',
      submitType: '',
      formData: {
        id: 0,
        areas: '',
        saiqu_name: '',
        danwei: '',
        ldname: '',
        weixin: '',
        phone: '',
        email: '',
        province: '',
        city: '',
        county: '',
      },
    }
  },
  filters: {},
  mounted() {
    let that = this;
    that.areaList = area;
    that.formData.id = this.$route.query.id;
    document.title = '联系人信息';
    that.fetch();
    that.getAreaOptions()
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {

    getAreaOptions() {
      let that = this;
      that.$api.post("/api/utils/areaTree", {}, (res) => {
        that.areaOptions = res.data;
        that.namekeyList = res.data;
      });
    },
    handleAreasChange(values) {
      let data = this.$refs.areas.getCheckedNodes()[0].pathLabels;
      console.log("handleAreasChange", values, data);
      this.formData.area = values[2];
      this.formData.province = data[0];
      this.formData.city = data[1];
      this.formData.county = data[2];
    },

    onAreaConfirm(values) {
      console.log(values);
      this.formData.area = values[2].code;
      this.formData.province = values[0].name;
      this.formData.city = values[1].name;
      this.formData.county = values[2].name;
      this.showArea = false;
    },
    fetch() {
      let that = this;
      that.$api.get('/api/songpei/step1Detail', {
        saiqu_id: that.saiqu_id,
        id: that.formData.id,
      }, (res) => {
        that.formData = res.data;

        console.log('Dialog');
        if (res.data.haveNoDone) {
          that.$confirm("建议您选择继续未完成的报名", "您有未完成的报名", {
                confirmButtonText: "继续未完成的报名",
                cancelButtonText: "重新报名",
                showClose: false,
                closeOnPressEscape: false,
                closeOnClickModal: false,
              })
              .then(() => {
                that.jumToOld();
              })
              .catch(() => {});
        }


      }, (res) => {

        console.log('没有登录');
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink({
              name: 'login', 'query': {}
            }, 'replace');
            return false;
          }
          that.loginShow = true
        } else {
          Toast(res.msg)
        }
      })
    },
    onQuestion() {
      console.log('onQuestion')
    },
    jumToOld(id) {
      rbLink({
        name: 'SongpeiApplyList'
      }, 'replace')
    },

    submitForm(formName) {
      const that = this;
      // 拿到地区的 省市区名称
      // that.formData["area"] = that.formData.areas[2];

      console.log(that.formData, that.$refs[formName]);
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          console.log(that.formData);
          that.saveLoading = true;
          that.$api.post(
              "/api/songpei/baoming",
              that.formData,
              (res) => {
                that.saveLoading = false;

                rbLink({
                  name: "SongpeiApplyFormStep1",
                  query: {
                    id: res.data.id,
                  },
                });
              },
              (res) => {
                that.$message.warning(res.msg);
                that.saveLoading = false;
              }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },
  }
}
</script>



// WEBPACK FOOTER //
// SongpeiApplyFormBasic.vue?d80a7bb8